import React from 'react';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useUpdateChecker } from '../../hooks/useUpdateChecker';

const VersionBanner = () => {
  const { updateAvailable, reload } = useUpdateChecker(60_000); // check every 60s

  if (!updateAvailable) return null;

  return (
    <Alert severity='info' icon={<DownloadIcon style={{marginTop: '0.25em'}}/>}>
      <Stack direction="row" alignItems="center" spacing={1}>      
        <Typography>A new app version is available to download.</Typography>
        <Button onClick={reload} style={{ marginLeft: 8 }}>
          Download
        </Button>
      </Stack>
    </Alert>
  );
}

export default VersionBanner;